import React, { useState } from "react";
import { toast } from "react-hot-toast";
import PinField from "react-pin-field";
import { authService } from "../../services/auth.service";
import Button from "../Button/Button";
import { useDispatch } from "react-redux";
import { setResetPin } from "../../redux/slices/userSlice";
import { useTranslation } from "react-i18next";
import { generateSecureToken } from "../../utils/navigateEditor";

const OTPVerifyModal = ({ setstate1, email }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [pin, setPin] = useState("");
  const { t, i18n } = useTranslation();

  const onSubmit = async (code) => {
    try {

      const token = generateSecureToken();

      if (!token) {
        setLoading(false);
        toast.error(t("Error occurred while submitting form"));
        return;
      }
      setLoading(true);
      const res = await authService.otpVerify({
        pin: parseInt(code),
        email: email,
        platform: "web",
        token,
      });
      //   console.log(res);
      if (res.status === 200 || res.status === 201) {
        dispatch(setResetPin(parseInt(code)));
        setLoading(false);
        setstate1(7);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      if (error?.response?.data?.msg) {
        toast.error(error?.response?.data?.msg);
      } else if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      } else {
        console.log(error.response);
      }
    }
  };

  return (
    <div className="w-full">
      <div className="flex flex-col md:gap-8 gap-4">
        <a
          href={`${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}`}
          className="cursor-pointer xl:w-36 w-30 h-12 relative flex-shrink-0 mx-auto"
        >
          <img
            src="https://gopdf.s3.eu-central-1.amazonaws.com/logos/Logo+go+pdf.svg"
            alt="Go PDF"
            fill={true}
            className="w-full h-full object-contain"
          />
        </a>
        <div>
          <h3 className="modal-heading mb-1">{t("OTP Verification")}</h3>
          <p className="modal-description !text-base">
            {t("Please enter the 4 digit code we have sent you.")}
          </p>
        </div>

        <div className="flex flex-col gap-10">
          <div className="grid grid-cols-4 flex-wrap mb-3 border border-secondary-30 rounded-lg divide-x divide-secondary-30">
            <PinField
              type="number"
              length={4}
              validate={/^[0-9]$/}
              onChange={async (pin) => {
                setPin(pin);
                if (pin && pin.length === 4) {
                  onSubmit(pin);
                }
              }}
              className="bg-transparent appearance-none overflow-y-auto text-secondary py-0.5 text-center md:text-3xl sm:text-2xl text-xl outline-none border-darkgrey focus:border-primary focus:shadow-primary"
            />
          </div>

          <Button
            isLoading={loading}
            onClick={() => {
              onSubmit(pin);
            }}
            value={t("Verify OTP")}
          />
        </div>
      </div>
    </div>
  );
};

export default OTPVerifyModal;
